import cx from 'classnames';
import type { FunctionComponent, ReactNode } from 'react';

import styles from './TreeViewLayout.module.less';

type Props = {
  header: ReactNode | string;
  children: ReactNode;
  className?: string;
};

/**
 * Table component for the TreeViewLayout.
 * Renders a container with an optional header and content area.
 */
export const TreeViewLayoutTable: FunctionComponent<Props> = ({ header, children, className }) => (
  <div className={cx(styles.table, className)}>
    <div className={styles.tableHeader}>
      {header}
    </div>
    <div className={styles.tableContent}>
      {children}
    </div>
  </div>
);
